

export default function RTKSection() {
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-[#2A6041] to-[#1a4029] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold mb-6">
            独自の取り組み
          </h2>
          <p className="text-xl text-green-100 mb-8">
            グループ独自のネットワークRTK基地局完備
          </p>
          <h3 className="text-4xl lg:text-5xl font-bold text-[#FFC107] mb-6">
            ランニングコストを、大幅に削減。
          </h3>
          <p className="text-lg text-green-100 max-w-4xl mx-auto leading-relaxed">
            自動操舵複数台導入時、通常はネットワークRTK月額費用が大きな負担(1台数千円×複数台=年間数十万円)。私たちは佐賀県・鹿児島県に自社RTK基地局を設置し、ランニングコスト削減と追加機器導入のしやすさを実現。
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          {/* 佐賀・福岡エリア */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8">
            <h4 className="text-2xl font-bold text-[#FFC107] mb-6">
              佐賀県・福岡県南部エリア
            </h4>
            <p className="text-lg font-medium text-green-100 mb-4">
              (IDS佐賀・川副教習所)
            </p>
            <ul className="space-y-3 text-green-100">
              <li className="flex items-start">
                <i className="ri-check-line text-[#FFC107] mr-3 mt-1 flex-shrink-0"></i>
                <span>佐賀県全域にRTK基地局を共同設置</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#FFC107] mr-3 mt-1 flex-shrink-0"></i>
                <span>弊社機器購入者に無償提供</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#FFC107] mr-3 mt-1 flex-shrink-0"></i>
                <span>導入台数に応じアカウント発行</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#FFC107] mr-3 mt-1 flex-shrink-0"></i>
                <span>福岡県南部(柳川・大川・みやま)もカバー</span>
              </li>
            </ul>
          </div>

          {/* 鹿児島エリア */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8">
            <h4 className="text-2xl font-bold text-[#FFC107] mb-6">
              鹿児島県エリア
            </h4>
            <p className="text-lg font-medium text-green-100 mb-4">
              (IDS鹿児島教習所)
            </p>
            <ul className="space-y-3 text-green-100">
              <li className="flex items-start">
                <i className="ri-check-line text-[#FFC107] mr-3 mt-1 flex-shrink-0"></i>
                <span>FAG-RTK基地局完備</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#FFC107] mr-3 mt-1 flex-shrink-0"></i>
                <span>他社より低価格で提供</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#FFC107] mr-3 mt-1 flex-shrink-0"></i>
                <span>将来的に無償システムへ移行検討</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#FFC107] mr-3 mt-1 flex-shrink-0"></i>
                <span>グループで基地局ネットワーク拡充中</span>
              </li>
            </ul>
          </div>
        </div>

        {/* 費用比較 */}
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 mb-12">
          <h4 className="text-2xl font-bold text-[#FFC107] mb-8 text-center">費用比較</h4>
          <div className="grid md:grid-cols-3 gap-6 text-center">
            <div className="bg-red-500/20 rounded-lg p-6">
              <h5 className="text-lg font-bold text-red-200 mb-2">通常</h5>
              <p className="text-sm text-red-100 mb-2">月額3,000円×3台×12ヶ月</p>
              <p className="text-2xl font-bold text-red-300">年間108,000円</p>
            </div>
            <div className="bg-[#FFC107]/20 rounded-lg p-6">
              <h5 className="text-lg font-bold text-yellow-200 mb-2">IDS佐賀・川副</h5>
              <p className="text-sm text-yellow-100 mb-2">無償提供</p>
              <p className="text-2xl font-bold text-[#FFC107]">年間0円</p>
            </div>
            <div className="bg-green-500/20 rounded-lg p-6">
              <h5 className="text-lg font-bold text-green-200 mb-2">IDS鹿児島</h5>
              <p className="text-sm text-green-100 mb-2">低価格提供</p>
              <p className="text-2xl font-bold text-green-300">大幅削減</p>
              <p className="text-xs text-green-200">(将来無償化予定)</p>
            </div>
          </div>
        </div>

        {/* RTK提供効果 */}
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 mb-12">
          <h4 className="text-xl font-bold text-[#FFC107] mb-6 text-center">この取り組みにより、お客様は:</h4>
          <div className="grid md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="flex items-center justify-center w-16 h-16 bg-[#FFC107] text-[#2A6041] rounded-full mx-auto mb-4">
                <i className="ri-money-dollar-circle-line text-2xl"></i>
              </div>
              <p className="text-green-100 font-medium">ランニングコストの大幅削減</p>
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center w-16 h-16 bg-[#FFC107] text-[#2A6041] rounded-full mx-auto mb-4">
                <i className="ri-add-circle-line text-2xl"></i>
              </div>
              <p className="text-green-100 font-medium">追加機器の導入がしやすい環境</p>
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center w-16 h-16 bg-[#FFC107] text-[#2A6041] rounded-full mx-auto mb-4">
                <i className="ri-speed-up-line text-2xl"></i>
              </div>
              <p className="text-green-100 font-medium">複数台導入によるさらなる効率化</p>
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center w-16 h-16 bg-[#FFC107] text-[#2A6041] rounded-full mx-auto mb-4">
                <i className="ri-time-line text-2xl"></i>
              </div>
              <p className="text-green-100 font-medium">初期投資の回収期間短縮</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

